export default [
    {
    // =============================================================================
    // MAIN LAYOUT ROUTES
    // =============================================================================
        path: '/main',
        redirect: '/',
        component: () => import('@/layouts/Main.vue'),
        children: [
            {
              path: '/',
              name: 'dashboard',
              component: () => import('@views/Dashboard.vue'),
              meta: {
                title: 'Dashboard',
                authRequired: true,
              }
            },
            {
              path: '/account',
              name: 'account',
              component: () => import('@views/account/UserAccount.vue'),
              meta: {
                title: 'Account',
                authRequired: true,
              },
            },
            {
              path: '/profile',
              name: 'profile',
              component: () => import('@views/profile/EmployeeShow.vue'),
              meta: {
                title: "Profile",
                authRequired: true,
              },
            },
            {
              path: '/payrolls',
              name: 'payrolls',
              component: () => import('@views/payrolls/PayrollList.vue'),
              meta: {
                title: "List of payrolls",
                authRequired: true,
              },
            },
            {
                path: "/payrolls/:payrollId(\\d+)",
                name: "payroll-view",
                component: () => import("@views/payrolls/PayrollShow.vue"),
                meta: {
                    title: "View Payroll",
                    authRequired: true,
                },
            },
            {
                path: "/loans",
                name: "loans",
                component: () => import("@views/deductions/LoanList.vue"),
                meta: {
                    title: "List of Employee Loans",
                    authRequired: true,
                },
            },
            {
                path: "/contributions",
                name: "contributions",
                component: () => import("@views/deductions/ContributionList.vue"),
                meta: {
                    title: "List of Contributions",
                    authRequired: true,
                },
            },
            {
                path: "/union-dues",
                name: "union-dues",
                component: () => import("@views/deductions/UnionDuesList.vue"),
                meta: {
                    title: "List of Union dues",
                    authRequired: true,
                },
            },
            {
                path: "/refunds",
                name: "refunds",
                component: () => import("@views/deductions/RefundList.vue"),
                meta: {
                    title: "List of Refunds",
                    authRequired: true,
                },
            },
            {
                path: "/arrears",
                name: "arrears",
                component: () => import("@views/allowances/ArrearList.vue"),
                meta: {
                    title: "List of Arrears",
                    authRequired: true,
                },
            },
            {
                path: "/allowances",
                name: "allowances",
                component: () =>
                    import("@views/allowances/AllowanceList.vue"),
                meta: {
                    title: "List of Allowances",
                    authRequired: true,
                },
            },
            {
                path: "/verifications",
                name: "verifications",
                component: () => import("@views/verifications/Verifications.vue"),
                meta: {
                    title: "Verifications",
                    authRequired: true,
                },
            },
            {
                path: "/verifications/:verificationId(\\d+)",
                name: "verification-show",
                component: () =>
                    import("@views/verifications/VerificationShow.vue"),
                meta: {
                    title: "View Verification",
                    authRequired: true,
                },
            },
            {
              path: '/access-codes',
              name: 'access-codes',
              component: () => import('@views/access-codes/AccessCodes.vue'),
              meta: {
                title: "Access codes",
                authRequired: true,
              }
            },
            {
              path: '/notifications',
              name: 'notifications',
              component: () => import('@views/notifications/NotificationList.vue'),
              meta: {
                title: "Notifications",
                authRequired: true,
              }
            },
        ]
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
        path: '/full',
        component: () => import('@/layouts/Full.vue'),
        children: [
          {
            path: '/login',
            name: 'login',
            component: () => import('@/views/pages/Login.vue'),
            meta: {
              guestRequired: true,
              title: "Login"
            }
          },
          {
            path: '/error-404',
            name: 'error-404',
            component: () => import('@/views/pages/Error404.vue'),
            meta: {
              title: "404 - Page not Found"
            }
          },
          {
            path: '/error-500',
            name: 'error-500',
            component: () => import('@/views/pages/Error500.vue'),
            meta: {
              title: "500 - Server error"
            }
          }
        ]
    },
    // Redirect to 404 page, if no match found
    {
        path: '/:any(.*)',
        redirect: '/error-404'
    },

]